import { render } from "./half-body.vue?vue&type=template&id=89f721c6&scoped=true"
import script from "./half-body.vue?vue&type=script&lang=js"
export * from "./half-body.vue?vue&type=script&lang=js"

import "./half-body.vue?vue&type=style&index=0&id=89f721c6&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89f721c6"]])

export default __exports__